import { useMemo, useState } from "react";
import styled, { keyframes } from "styled-components";

import arrow_down from "../assets/images/arrow_down.svg";

const MenuContainer = styled.div`
  width: fit-content;

  .dropdown-title {
    display: flex;
    align-items: center;

    p {
      margin-right: 8px;
    }

    .arrow_down {
      width: 16px;
      height: 16px;
      transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});
      transition: all 0.2s;
    }
  }

  ul {
    height: ${({ isOpen }) => (isOpen ? "auto" : "0")};
    overflow: hidden;
    transform: scaleY(${({ isOpen }) => (isOpen ? "1" : "0")});
    transform-origin: top;
    transition: all 0.2s ease;
    margin-top: 4px;
  }

  #dropdown-sub-item {
    padding: 4px 12px;
  }
`;

function DropdownMenu({
  title = "Title",
  subItensList = [{ text: "Subtitle", url: "/", border: false }],
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const renderedSubItems = useMemo(() => {
    return subItensList?.map((item) => (
      <a href={item.url} key={item.text}>
        <li
          style={{
            borderBottom: `${
              item.border ? "1px solid #626262" : null
            }`,
          }}
          id="dropdown-sub-item"
        >
          {item.text}
        </li>
      </a>
    ));
  }, [subItensList]);

  return (
    <MenuContainer isOpen={isOpen} onClick={toggleMenu}>
      <div className="dropdown-title">
        <p>{title}</p>
        <img className="arrow_down" src={arrow_down} alt="" />
      </div>
      <ul>{renderedSubItems}</ul>
    </MenuContainer>
  );
}

export default DropdownMenu;
